import { WriterInformation } from './WriterInformation'
import { withWriterInformation } from './withWriterInformation'

const ConnectedWriterInformation = withWriterInformation(WriterInformation)

export { ConnectedWriterInformation as WriterInformation }
